// Mid-sweep resume point for the changes/get full sync (WEB-7061).
//
// The sweep's durable watermark is changesLastCalled, which only advances once a
// sweep finishes. This slice holds the resume key the server returns on every
// seek-paged response, so a sweep interrupted at page N resumes at page N instead
// of re-fetching everything from the watermark. WEB-7060 stopped the re-fetch
// storm; this stops paying for the pages the sweep had already fetched.
//
// Session-only — blacklisted from redux-persist alongside changesLastCalled. A
// hard refresh is deliberately a full pull (see the store.js blacklist comment),
// and a checkpoint that outlived the reload would defeat that.

export const SYNC_CHECKPOINT_SET = 'SYNC_CHECKPOINT_SET'
export const SYNC_CHECKPOINT_CLEAR = 'SYNC_CHECKPOINT_CLEAR'

// Both halves are required, and cursorId is not optional decoration. `cursor` is
// a ServerModifiedUtc stamp, which is NOT unique — a bulk import lands hundreds
// of rows on the same stamp. The server only guarantees forward progress when it
// can seek strictly past the (stamp, id) PAIR:
//
//   e.ServerModifiedUtc > afterStamp ||
//   (e.ServerModifiedUtc == afterStamp && e.Id > afterId)
//
// (ChangeFeedPaging.PageForChanges, API-3552). Checkpointing the stamp alone
// would either re-serve or skip the rows sharing it.
export const setSyncCheckpoint = (cursor, cursorId) => ({
  type: SYNC_CHECKPOINT_SET,
  payload: { cursor, cursorId },
})

export const clearSyncCheckpoint = () => ({
  type: SYNC_CHECKPOINT_CLEAR,
})
